var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowFlowerSticker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_1526)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_173_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.048 34.2309C13.0383 35.8639 15.8673 37.4605 19.8002 38.637C22.1328 39.3347 24.2253 39.7791 26.0787 40.0369C25.2162 40.0956 24.3038 40.1831 23.3389 40.3029C18.5331 40.8991 15.197 41.9734 12.9271 43.1953C8.56583 45.543 10.2512 51.3204 15.1034 52.3144C17.6255 52.8311 20.8726 52.9245 24.9003 52.1315C27.6851 51.5833 30.0207 50.8826 31.9578 50.1222C32.6833 49.8374 33.325 49.4812 33.8808 49.0742C33.0056 49.8542 32.0888 50.7406 31.1307 51.7456C27.789 55.2507 25.8876 58.1948 24.9047 60.578C23.0164 65.1569 27.9795 68.5607 32.3642 66.257C34.6433 65.0596 37.2154 63.0755 39.8302 59.911C41.6381 57.7231 43.0019 55.7017 44.0195 53.8864C44.9112 52.2957 45.2003 50.6925 45.0323 49.2999C45.3886 50.2564 46.019 51.1733 46.9416 51.9302C48.9319 53.5633 51.7609 55.1599 55.6937 56.3363C58.4129 57.1497 60.8058 57.6188 62.874 57.8493C69.1317 58.5469 72.7298 52.5695 67.5402 49.0039C65.6729 47.7209 63.1633 46.4057 59.8276 45.144C57.7475 44.3572 55.8946 43.8041 54.2492 43.4382C56.4373 43.3723 58.8751 42.9703 61.5271 42.0701C65.4011 40.7552 68.2141 39.1761 70.216 37.6211C74.1652 34.5534 72.9974 28.4072 67.3801 27.3832C64.3995 26.8399 60.4079 26.9019 55.204 28.1782C54.9632 28.2373 54.7266 28.2974 54.4941 28.3584C55.5744 26.9047 56.4528 25.5379 57.1628 24.2714C60.2417 18.7791 56.1369 13.1377 50.8321 16.5295C48.9234 17.7499 46.7348 19.5494 44.274 22.1306C42.4412 24.053 41.0416 25.8067 39.9893 27.3916C39.6845 26.4664 39.3269 25.4875 38.9107 24.4528C37.1037 19.9599 35.211 17.0101 33.4485 15.1288C30.0623 11.5141 24.9091 14.6228 25.1908 19.5677C25.3371 22.1381 26.0783 25.3008 27.8763 28.9912C27.9073 29.0548 27.9383 29.1181 27.9693 29.1811C26.7818 28.5967 25.4424 28.0152 23.9341 27.4447C19.4045 25.7314 15.9524 25.1263 13.3746 25.1489C8.42177 25.1924 7.21902 31.0891 11.048 34.2309ZM40.3684 36.9246C38.8968 38.7094 36.0668 38.9123 33.6391 37.2659C32.9695 38.5116 31.6572 39.5249 29.9308 39.9667C30.6553 39.9946 31.3313 40.0474 31.9615 40.1214C36.976 40.7105 37.7149 45.3061 34.7888 48.2902C35.8177 47.4306 36.7846 46.7226 37.6888 46.1445C40.9416 44.0647 43.7433 45.3814 44.7141 47.9775C44.4334 45.5043 45.891 43.1318 48.7875 42.8716L48.7522 42.8627C45.7408 42.1042 43.3661 39.759 42.9546 37.3708C42.0292 37.4279 41.143 37.2644 40.3684 36.9246Z",
    fill: "#F7E023"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_173_1526)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0809,
    cy: 40.4686,
    rx: 10.0809,
    ry: 10.4686,
    fill: "#9CCB0E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_173_1526",
    x: 8.78638,
    y: 13.5588,
    width: 63.7555,
    height: 53.4381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_173_1526"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_173_1526",
    x: 30,
    y: 30,
    width: 20.1619,
    height: 20.9373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_173_1526"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_1526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFlowerSticker);
export default __webpack_public_path__ + "static/media/yellow_flower_sticker.8074dec86bfbdd17a10d32b8941fc1fb.svg";
export { ForwardRef as ReactComponent };